<template>
  <ol v-bind:id="id" class="material-design-steps">
    <slot v-bind:value="value"/>
  </ol>
</template>

<script>
export default {
  name: "steps",
  props: ["id", "value"]
}
</script>
